import React, { useMemo, useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table';
import { formatInCST } from '../utils/timezone';

function installDate(value) {
  if (!value) return 'Not reported';
  const raw = String(value);
  if (/^\d{8}$/.test(raw)) return raw.slice(0,4) + '-' + raw.slice(4,6) + '-' + raw.slice(6);
  try { return formatInCST(value, 'MMM d, yyyy'); } catch { return 'Not reported'; }
}
export default function SoftwareInventory({ software }) {
  const [search,setSearch] = useState('');
  const [page,setPage] = useState(1);
  const [pageSize,setPageSize] = useState(10);
  const rows = useMemo(() => (Array.isArray(software) ? software : []).filter(sw => sw && typeof sw === 'object')
    .filter(sw => [sw.name,sw.displayName,sw.version,sw.displayVersion,sw.publisher].some(v => String(v || '').toLowerCase().includes(search.toLowerCase().trim())))
    .sort((a,b) => String(a.name || a.displayName || '').localeCompare(String(b.name || b.displayName || ''))), [software,search]);
  const pages = Math.max(1,Math.ceil(rows.length/pageSize));
  const currentPage = Math.min(page,pages);
  const start = (currentPage-1)*pageSize;
  return <div className="space-y-3 asset-software-inventory">
    <div className="flex flex-wrap gap-3 items-center">
      <Input aria-label="Search installed software" placeholder="Search name, publisher, or version…" value={search} onChange={e => {setSearch(e.target.value);setPage(1);}} className="min-w-0 flex-1" />
      <label className="flex items-center gap-2 text-sm">Rows
        <select aria-label="Software rows per page" value={pageSize} onChange={e => {setPageSize(Number(e.target.value));setPage(1);}}>
          {[10,25,50].map(n => <option key={n} value={n}>{n}</option>)}
        </select>
      </label>
    </div>
    <Table className="table-fixed">
      <TableHeader><TableRow><TableHead className="w-[40%]">Software name</TableHead><TableHead>Version</TableHead><TableHead>Publisher</TableHead><TableHead>Install date</TableHead></TableRow></TableHeader>
      <TableBody>{rows.slice(start,start+pageSize).map((sw,i) => <TableRow key={start+i}>
        <TableCell className="font-medium break-words">{sw.name || sw.displayName || 'Unknown'}</TableCell>
        <TableCell className="font-mono text-xs break-words">{sw.version || sw.displayVersion || 'Not reported'}</TableCell>
        <TableCell className="break-words">{sw.publisher || 'Not reported'}</TableCell>
        <TableCell>{installDate(sw.installDate)}</TableCell>
      </TableRow>)}{!rows.length && <TableRow><TableCell colSpan={4} className="text-center py-6">No matching software</TableCell></TableRow>}</TableBody>
    </Table>
    <div className="flex flex-wrap items-center justify-between gap-3 text-sm">
      <p role="status">{rows.length ? start+1 : 0}–{Math.min(start+pageSize,rows.length)} of {rows.length} applications</p>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" aria-label="Previous software page" disabled={currentPage <= 1} onClick={() => setPage(currentPage-1)}>Previous</Button>
        <span>Page {currentPage} of {pages}</span>
        <Button variant="outline" size="sm" aria-label="Next software page" disabled={currentPage >= pages} onClick={() => setPage(currentPage+1)}>Next</Button>
      </div>
    </div>
  </div>;
}
